<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>模拟盘转账</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create :tenant-list="tenantList" @refresh="getList"></create>
        <el-input placeholder="请输入转入账号" clearable v-model="userId">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select v-model="tenantId" placeholder="租户选择" clearable>
          <el-option
            v-for="item in tenantList"
            :key="item.id"
            :label="item.tenantName"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
      </div>
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import List from "./components/list";
import Create from "./components/create";
import moment from "moment";
import { tenantInfo } from "@/common/publicApi";
export default {
  name: "TransferInnerMock",
  data() {
    return {
      userId: "",
      tenantId: "",
      tenantList: [],
    };
  },
  components: {
    List,
    Create,
  },
  computed: {
    ...mapState("transferInnerMock", ["pagination"]),
    ...mapGetters("transferInnerMock", ["list"]),
  },
  methods: {
    ...mapActions("transferInnerMock", ["reqList", "getCoinTypes"]),
    handleSearch() {
      this.getList({ page: 1, size: 25, userId: this.userId });
    },
    getList(data = {}) {
      this.reqList({
        userId: this.userId,
        ...this.pagination,
        tenantId: this.tenantId,
        ...data,
      });
    },
  },
  mounted() {
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });
    this.getCoinTypes();
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.actions-bar {
  display: flex;
  align-items: center;
}

.el-input {
  width: 300px;
}

.el-date-editor,
.el-input {
  margin-right: 10px;
}
</style>
